import { Int } from '@adornis/baseql/baseqlTypes.js';
import { registerQuery } from '@adornis/baseql/metadata/register.js';
import { getRawCollection } from '@adornis/baseql/server/collections.js';
import { hasNexusPermission } from '@nsc/nexus-permissions/nexus-api/nexus-permission-gate.js';
import { NexusPermission } from '@nsc/nexus-permissions/platform-rbac/nexus-permissions.js';
import { startOfMonth, subMonths } from 'date-fns';
import { PartnerSchedulingTaskState } from '../entities/PartnerSchedulingTaskState.js';

export const subscribeFlashGlobalSchedulingsInitiatedCount = registerQuery({
  operationName: 'subscribeFlashGlobalSchedulingsInitiatedCount',
  type: () => [Int],
  resolve: () => async () => {
    if (!(await hasNexusPermission(NexusPermission.ClientStats))) {
      return [0, 0];
    }

    const col = await getRawCollection(PartnerSchedulingTaskState._collectionName);

    const now = new Date();
    const startCurrentMonth = startOfMonth(now);
    const startPreviousMonth = startOfMonth(subMonths(now, 1));

    const baseFilter = {
      clientName: { $regex: /flash global/i },
    };

    const [currentMonthCount, previousMonthCount] = await Promise.all([
      col.countDocuments({
        ...baseFilter,
        subticketCreatedAt: { $gte: startCurrentMonth },
      }),
      col.countDocuments({
        ...baseFilter,
        subticketCreatedAt: { $gte: startPreviousMonth, $lt: startCurrentMonth },
      }),
    ]);

    return [currentMonthCount, previousMonthCount];
  },
});
